export const LADE_AUSWAHLWERTE_AGRIVIVA_FIRMA = "ladeAuswahlwerteAgrivivaFirma";
